import React, {Component} from "react";
import {APIClient} from "../../utils/APIClient";
import {API_URL} from "../../settings/local_settings";
import {Spinner} from "../Spinner";
import {SubmitButton} from "../buttons/SubmitButton";
import {AgencyFormFieldError} from "./AgencyFormFieldError";
import {Switch} from "../buttons/Swtich";
import { withTranslation } from 'react-i18next';

class AgencyInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            savingChanges: false,
            agencyInfo: null,
            countryOptions: null,
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    getCountries() {
        new APIClient(API_URL + 'countries/').call('GET').then((data) => {
            if (data.status === 'ERROR') {
                alert(data['error_message']);
            } else if (data.status === 'OK') {
                this.setState({
                    countryOptions: data['countries']
                });
            }
        });
    }

    getGeneralData() {
        new APIClient(API_URL + 'get-agency-data/').call('GET').then((data) => {
            if (data.status === 'ERROR_NO_AGENCY') {
                alert(data['error_message']);
                this.redirectToAgencyRegisterPage()
            } else if (data.status === 'OK') {
                this.setState({
                    agencyInfo: {
                        name: data.general_data.name,
                        creatorName: data.general_data.creator_name,
                        country: data.general_data.country,
                        amountOfPeople: data.general_data.amount_of_people,
                        phoneNumber: data.general_data.phone_number,
                        website: data.general_data.website,
                        allow_set_first_day_on_periodic_business_units: data.general_data.allow_set_first_day_on_periodic_business_units || false,
                        daily_limit_multiple_notifications_mode_enabled: data.general_data.daily_limit_multiple_notifications_mode_enabled || false,
                        logo_url: data.general_data.logo_url || '',
                        display_name_for_clients: data.general_data.display_name_for_clients || '',
                        brand_primary_color: data.general_data.brand_primary_color || '',
                        brand_secondary_color: data.general_data.brand_secondary_color || '',
                        errors: {}
                    }
                });
            }
        })
    }

    componentDidMount() {
        this.getGeneralData();
        this.getCountries();
    }

    _editAgencyUrl() {
        return API_URL + 'edit-agency/';
    }

    handleSubmit() {
        const { t } = this.props;
        this.setState({savingChanges: true});
        new APIClient(this._editAgencyUrl()).call('POST', {
            'amount_of_people': this.state.agencyInfo.amountOfPeople,
            'name': this.state.agencyInfo.name,
            'creator_name': this.state.agencyInfo.creatorName,
            'country': this.state.agencyInfo.country,
            'phone_number': this.state.agencyInfo.phoneNumber,
            'website': this.state.agencyInfo.website,
            'allow_set_first_day_on_periodic_business_units': this.state.agencyInfo.allow_set_first_day_on_periodic_business_units,
            'daily_limit_multiple_notifications_mode_enabled': this.state.agencyInfo.daily_limit_multiple_notifications_mode_enabled,
            'logo_url': this.state.agencyInfo.logo_url || '',
            'display_name_for_clients': this.state.agencyInfo.display_name_for_clients || '',
            'brand_primary_color': this.state.agencyInfo.brand_primary_color || '',
            'brand_secondary_color': this.state.agencyInfo.brand_secondary_color || ''
        }).then((data) => {
            this.setState({savingChanges: false});
            let errors = [];
            if (data.status === 'ERROR') {
                errors = JSON.parse(data.errors);
            } else if (data.status === 'ERROR_USER_DOES_NOT_HAVE_ACCESS') {
                alert(data['error_message']);
            } else if (data.status === 'OK') {
                alert(t('agency_info.changes_saved_successfully'));
            }
            this.setState({
                agencyInfo: {
                    ...this.state.agencyInfo,
                    errors: errors
                }
            });
        });
    }

    handleChange(event) {
        const target = event.target;
        const name = target.name;
        const value = target.type === 'checkbox' ? target.checked : target.value;

        this.setState({
            agencyInfo: {
                ...this.state.agencyInfo,
                [name]: value
            }
        });
    }

    renderCountriesOptions() {
        const { t } = this.props;
        if (this.state.countryOptions !== null) {
            return this.state.countryOptions.map((country) =>
                <option key={country[0]} value={country[0]}>
                    {country[1]}
                </option>
            );
        } else {
            return <option>{t('agency_info.loading')}</option>
        }
    }

    renderSaveButton() {
        const { t } = this.props;
        if (this.state.savingChanges) {
            return <Spinner color="positive small"/>;
        } else {
            return <SubmitButton onClick={this.handleSubmit} value={t('agency_info.save_button')}/>;
        }
    }

    renderAgencyInfo() {
        const { t } = this.props;
        if (this.state.agencyInfo !== null) {
            return (
                <div className="agency-profile-grid">
                    <section className="box agency-profile-card">
                        <header className="box-header">
                            <h2 className="box-title">{t('agency_info.agency_data_title')}</h2>
                        </header>
                        <div className="form-grid row-col-2">
                            <div className="form-item">
                                <label><span title={t('agency_info.required_field')}>*</span>{t('agency_info.agency_name')}</label>
                                <input onChange={this.handleChange} name="name" type="text"
                                       value={this.state.agencyInfo.name}/>
                                <AgencyFormFieldError errors={this.state.agencyInfo.errors} fieldName="name"/>
                            </div>
                            <div className="form-item">
                                <label><span title={t('agency_info.required_field')}>*</span>{t('agency_info.employee_count')}</label>
                                <input onChange={this.handleChange} name="amountOfPeople"
                                       type="number" min={1} value={this.state.agencyInfo.amountOfPeople}
                                       required="required"/>
                                <AgencyFormFieldError errors={this.state.agencyInfo.errors}
                                                      fieldName="amount_of_people"/>
                            </div>
                        </div>
                        <div className="form-grid row-col-2">
                            <div className="form-item">
                                <label><span title={t('agency_info.required_field')}>*</span>{t('agency_info.country')}</label>
                                <select onChange={this.handleChange} name="country" required="required"
                                        value={this.state.agencyInfo.country}>
                                    {this.renderCountriesOptions()}
                                </select>
                                <AgencyFormFieldError errors={this.state.agencyInfo.errors} fieldName="country"/>
                            </div>
                            <div className="form-item">
                                <label><span title={t('agency_info.required_field')}>*</span>{t('agency_info.website')}</label>
                                <input onChange={this.handleChange} name="website" type="text" required="required"
                                       value={this.state.agencyInfo.website}/>
                                <AgencyFormFieldError errors={this.state.agencyInfo.errors} fieldName="website"/>
                            </div>
                        </div>
                        <div className="form-grid row-col-2">
                            <div className="form-item">
                                <label>{t('agency_info.contact_name')}</label>
                                <input onChange={this.handleChange} name="creatorName" type="text"
                                       value={this.state.agencyInfo.creatorName}/>
                                <AgencyFormFieldError errors={this.state.agencyInfo.errors} fieldName="creator_name"/>
                            </div>
                            <div className="form-item">
                                <label>{t('agency_info.phone_number')}</label>
                                <input onChange={this.handleChange} name="phoneNumber" type="text"
                                       value={this.state.agencyInfo.phoneNumber}/>
                                <AgencyFormFieldError errors={this.state.agencyInfo.errors} fieldName="phoneNumber"/>
                            </div>
                        </div>
                        <div className="form-row -v-center">
                            <div className="d-flex align-items-center">
                                <Switch onChange={this.handleChange}
                                        name="allow_set_first_day_on_periodic_business_units"
                                        className="me-2" checked={!!this.state.agencyInfo.allow_set_first_day_on_periodic_business_units}/>
                                <label className="m-0">{t('agency_info.monthly_control_line_description')}</label>
                            </div>
                        </div>
                        <div className="form-row -v-center">
                            <div className="d-flex align-items-center">
                                <Switch onChange={this.handleChange}
                                        name="daily_limit_multiple_notifications_mode_enabled"
                                        className="me-2" checked={!!this.state.agencyInfo.daily_limit_multiple_notifications_mode_enabled}/>
                                <label className="m-0">{t('agency_info.daily_limit_notifications_description')}</label>
                            </div>
                        </div>
                    </section>
                    <section className="box agency-profile-card">
                        <header className="box-header">
                            <h2 className="box-title">{t('agency_info.client_branding_title')}</h2>
                        </header>
                        <div className="form-grid row-col-2">
                            <div className="form-item">
                                <label>{t('agency_info.logo_url')}</label>
                                <input onChange={this.handleChange} name="logo_url" type="text"
                                       placeholder="https://..."
                                       value={this.state.agencyInfo.logo_url || ''}/>
                            </div>
                            <div className="form-item">
                                <label>{t('agency_info.display_name_for_clients')}</label>
                                <input onChange={this.handleChange} name="display_name_for_clients" type="text"
                                       placeholder={this.state.agencyInfo.name}
                                       value={this.state.agencyInfo.display_name_for_clients || ''}/>
                            </div>
                        </div>
                        <div className="form-grid row-col-2">
                            <div className="form-item">
                                <label>{t('agency_info.brand_primary_color')}</label>
                                <div className="brand-color-input">
                                    <input type="color"
                                           value={this.state.agencyInfo.brand_primary_color || '#FF470F'}
                                           onChange={e => this.handleChange({target: {name: 'brand_primary_color', value: e.target.value}})} />
                                    <input type="text" name="brand_primary_color"
                                           value={this.state.agencyInfo.brand_primary_color || ''}
                                           onChange={this.handleChange} placeholder="#FF470F" maxLength={7} />
                                    {this.state.agencyInfo.brand_primary_color && (
                                        <button type="button" className="brand-color-clear"
                                                onClick={() => this.handleChange({target: {name: 'brand_primary_color', value: ''}})}>
                                            {t('agency_info.clear_color')}
                                        </button>
                                    )}
                                </div>
                            </div>
                            <div className="form-item">
                                <label>{t('agency_info.brand_secondary_color')}</label>
                                <div className="brand-color-input">
                                    <input type="color"
                                           value={this.state.agencyInfo.brand_secondary_color || '#440631'}
                                           onChange={e => this.handleChange({target: {name: 'brand_secondary_color', value: e.target.value}})} />
                                    <input type="text" name="brand_secondary_color"
                                           value={this.state.agencyInfo.brand_secondary_color || ''}
                                           onChange={this.handleChange} placeholder="#440631" maxLength={7} />
                                    {this.state.agencyInfo.brand_secondary_color && (
                                        <button type="button" className="brand-color-clear"
                                                onClick={() => this.handleChange({target: {name: 'brand_secondary_color', value: ''}})}>
                                            {t('agency_info.clear_color')}
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            )
        } else {
            return (
                <div className="box-loader">
                    <Spinner color="positive"/>
                </div>
            )
        }
    }

    render() {
        return (
            <form className="section-body-item agency-profile-form">
                {this.renderAgencyInfo()}
                <div className="submit-row">
                    {this.renderSaveButton()}
                </div>
            </form>
        )
    }
}

export default withTranslation()(AgencyInfo);
